import React from "react";
import { Box, Typography, IconButton, alpha, useTheme } from "@mui/material";
import { Close } from "@mui/icons-material";

/**
 * Reusable Dialog Header Component
 * Used in PaymentSplitDialog and CashPaymentDialog for consistent design
 *
 * @param {React.Element} icon - Icon to display in the header (e.g., <CreditCard />)
 * @param {string} title - Main title text
 * @param {string} subtitle - Subtitle/description text (optional)
 * @param {function} onClose - Close button click handler
 */
const DialogHeader = ({ icon, title, subtitle, onClose }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: 2.5,
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        color: "white",
        position: "relative",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {/* Icon Box */}
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            bgcolor: alpha("#fff", 0.2),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>

        {/* Title and Subtitle */}
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 900 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              {subtitle}
            </Typography>
          )}
        </Box>

        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            color: "white",
            bgcolor: alpha("#fff", 0.1),
            "&:hover": { bgcolor: alpha("#fff", 0.2) },
          }}
        >
          <Close />
        </IconButton>
      </Box>
    </Box>
  );
};

export default DialogHeader;
